import { MoreQuestionsSectionProps } from '../../types/components/pricing/MoreQuestionsSection';

import markdownHelpers from '../../helpers/markdown';

const MoreQuestionsSection: React.FC<MoreQuestionsSectionProps> =({
  pageContent
}) => {
  if (!pageContent) return;

  const { convertMarkdownToHtml } = markdownHelpers;

  return (
    <section className="max-h-[152px] bg-[#252B2D] flex flex-col items-center justify-center p-6 gap-2 md:gap-6" cy-test-id="more-questions">
      <div
        cy-test-id="heading"
        className="eurostile uppercase font-bold text-white text-[16px] md:text-[28px] md:leading-[36px] tracking-[3%] whitespace-pre"
        dangerouslySetInnerHTML={{
          __html: convertMarkdownToHtml(pageContent.cta_heading)
        }}
      />
      <div
        cy-test-id="subheading"
        className="font-extralight text-white text-[12px] md:text-[16px] md:leading-[24px]"
        dangerouslySetInnerHTML={{
          __html: convertMarkdownToHtml(pageContent.cta_sub_heading)
        }}
      />
    </section>
  )
}

export default MoreQuestionsSection;
